module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth"
  }, [_c('h1', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('div', {
    staticClass: "auth-block"
  }, [_c('h2', [_vm._v("Вход в систему")]), _vm._v(" "), _c('div', {
    staticClass: "auth-field"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Электронная почта")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "auth-field"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Пароль")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.logMe.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "auth-field"
  }, [_c('label', {
    attrs: {
      "for": "actButton"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button action-button",
    attrs: {
      "href": "#",
      "id": "actButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logMe.apply(null, arguments)
      }
    }
  }, [_vm._v("Войти")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-547762ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth.vue
// module id = 245
// module chunks = 1